import React from "react";
import Logo from "../components/Logo";

function AuthLayout({ title, children, subtitle }) {
  return (
    <div className="flex min-h-screen flex-1 flex-col justify-center py-12 px-6 lg:px-8 bg-gray-50 font-sans">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <Logo className="mx-auto h-12 w-auto" />
        <h2 className="mt-10 text-center text-3xl font-bold leading-9 tracking-tight text-primary-900">
          {title}
        </h2>
        {subtitle && (
          <p className="mt-2 text-center text-sm text-gray-500">{subtitle}</p>
        )}
      </div>
      <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-[480px]">
        <div className="bg-white px-6 py-12 shadow sm:rounded-lg sm:px-12 border border-gray-100">
          {children}
        </div>
      </div>
    </div>
  );
}

export default AuthLayout;
